'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiRefresh = function TiRefresh(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.5 22h8.5v-8.6c0-1.9-1.1-2.3-2.5-1l-1.9 2c-1.7-1.4-3.7-2.1-5.9-2.1-2.6 0-5 1-6.9 2.8-1.8 1.9-2.8 4.3-2.8 6.9 0 2.6 1 5 2.8 6.8 1.9 1.9 4.3 2.9 6.9 2.9 2.6 0 5-1 6.8-2.9 0.5-0.5 1-1 1.3-1.6 0.6-0.9 0.3-2.1-0.6-2.7-0.9-0.5-2.1-0.3-2.6 0.6-0.3 0.4-0.5 0.7-0.8 1-1.1 1.1-2.6 1.7-4.1 1.7s-3-0.6-4.1-1.7c-1.1-1.1-1.7-2.6-1.7-4.1 0-1.6 0.6-3 1.7-4.1 1.1-1.1 2.5-1.7 4.1-1.7 1.1 0 2.2 0.3 3.2 0.9l-2.5 2.5c-1.3 1.3-0.8 2.4 1.1 2.4z' })
        )
    );
};

exports.default = TiRefresh;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/refresh.js
// module id = 1991
// module chunks = 0